import styled from 'styled-components'
import TransparentButton from '../../button/TransparentButton'

const CategoryLink = styled(TransparentButton).attrs({
  $size: 'small',
})`
  overflow: hidden;
  text-overflow: ellipsis;
`

export default CategoryLink
